import { render, staticRenderFns } from "./ViewerMaster.vue?vue&type=template&id=aff02a40&scoped=true"
import script from "./ViewerMaster.vue?vue&type=script&lang=js"
export * from "./ViewerMaster.vue?vue&type=script&lang=js"
import style0 from "./ViewerMaster.vue?vue&type=style&index=0&id=aff02a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff02a40",
  null
  
)

export default component.exports